<template>
    <div class="main lancamento-notas">

        <c-panel>
            <div v-if="carregandoInit" class="u-text-center" style="min-height: 90px;">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" @submit.native.prevent="buscar()">
                <el-alert v-if="dados.somente_consulta" type="info" :closable="false" show-icon class="u-mb-10"
                    title="Ano letivo diferente do corrente: somente consulta."></el-alert>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="4">
                        <el-form-item label="Ano letivo">
                            <el-select :value="anoLetivo" placeholder="Ano letivo" style="width: 100%" @change="trocarAnoLetivo">
                                <el-option v-for="item in $store.state.periodos" :key="item.id" :label="item.nome" :value="Number(item.id)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="precisaEscolherInstituicao" :xs="24" :sm="18" :md="20">
                        <el-form-item label="Instituição">
                            <el-select :value="instituicaoId" filterable placeholder="Selecione a instituição" style="width: 100%" @change="trocarInstituicao">
                                <el-option v-for="item in $store.state.instituicoes" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="10">
                        <el-form-item label="Turma">
                            <el-select :value="filtro.turma" filterable placeholder="Selecione a turma" style="width: 100%" @change="(v) => trocarFiltro('turma', v)">
                                <el-option v-for="turma in turmasVisiveis" :key="turma.id"
                                    :label="`${String(turma.nome || '').toUpperCase()}${turma.fase_diario == 5 ? ' (ENCERRADO)' : ''}`" :value="turma.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="7">
                        <el-form-item label="Disciplina">
                            <el-select :value="filtro.disciplina" placeholder="Selecione a disciplina" style="width: 100%"
                                :disabled="!turmaSelecionada || turmaParecer" @change="(v) => trocarFiltro('disciplina', v)">
                                <el-option v-if="turmaParecer" key="parecer" label="Parecer (turma sem nota)" value="parecer"></el-option>
                                <template v-else>
                                    <el-option v-if="dados.pode_lancar_por_turma" key="todas" label="Todas as disciplinas" value="todas"></el-option>
                                    <el-option v-for="d in disciplinas" :key="d.id" :label="d.nome" :value="String(d.id)"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="7">
                        <el-form-item label="Período">
                            <el-select :value="filtro.periodo" placeholder="Selecione o período" style="width: 100%"
                                :disabled="!filtro.disciplina" @change="(v) => trocarFiltro('periodo', v)">
                                <el-option v-for="p in periodos" :key="p.periodo" :value="p.periodo"
                                    :label="`${p.nome}${!p.aberto ? ' (somente leitura)' : ''}`">
                                    <span>{{ p.nome }}</span>
                                    <span v-if="!p.aberto" class="ln-opcao-info"> (somente leitura)</span>
                                    <span v-else-if="periodoPendente(p)" class="ln-opcao-pendente">pendente</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button type="primary" native-type="submit" :disabled="!filtrosCompletos" :loading="carregando">Buscar</el-button>
                        <el-button @click="limpar()">Limpar</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>

        <c-panel v-if="carregando">
            <div class="u-text-center" style="min-height: 90px;">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <c-panel v-else-if="lancamento">

            <el-alert v-if="lancamento.somente_leitura" type="info" :closable="false" show-icon class="u-mb-10"
                :title="lancamento.motivo_somente_leitura || 'Somente leitura.'"></el-alert>
            <el-alert v-if="lancamento.aviso" type="warning" :closable="false" show-icon class="u-mb-10" :title="lancamento.aviso"></el-alert>
            <el-alert v-if="qtdConflitos" type="warning" :closable="false" show-icon class="u-mb-10"
                :title="`${qtdConflitos} nota(s) foram alteradas por outra pessoa enquanto você editava e não foram gravadas (marcadas em laranja). Dê um duplo clique na célula para usar o valor atual, ou digite de novo e salve.`"></el-alert>

            <div class="ln-ultimo">
                <template v-if="lancamento.atualizacao">
                    Última alteração: <b>{{ lancamento.atualizacao.por || '—' }}</b> em {{ formatarDataHora(lancamento.atualizacao.em) }}
                </template>
            </div>

            <grade
                :disciplinas="lancamento.disciplinas"
                :alunos="alunos"
                :anteriores="anteriores"
                :erros="erros"
                :conflitos="conflitos"
                :somente-leitura="lancamento.somente_leitura"
                :media-minima="dados.media_minima || 5"
                :com-parecer="filtro.periodo != 'r'"
                @aplicar-conflito="aplicarConflito"
                @abrir-parecer="abrirParecer" />

            <el-dialog :visible.sync="parecer.aberto" :close-on-click-modal="false" width="70%" append-to-body
                :title="parecer.aluno ? `PARECER — ${parecer.aluno.nome}` : 'PARECER'">
                <div v-if="parecer.aluno" class="u-mt-20">
                    <p class="ln-parecer-periodo">{{ nomePeriodoAtual }}</p>
                    <el-alert v-if="!lancamento.pode_parecer" type="info" :closable="false" show-icon class="u-mb-10"
                        :title="lancamento.motivo_parecer || 'Somente leitura.'"></el-alert>
                    <el-input type="textarea" v-model="parecer.texto" :rows="10" maxlength="10000" show-word-limit
                        :disabled="!lancamento.pode_parecer" placeholder="Escreva o parecer do aluno neste bimestre"></el-input>
                    <div class="u-text-right u-mt-15">
                        <el-button @click="parecer.aberto = false">{{ lancamento.pode_parecer ? 'Cancelar' : 'Fechar' }}</el-button>
                        <el-button v-if="lancamento.pode_parecer" type="primary" :loading="parecer.salvando" @click="salvarParecer()">Salvar parecer</el-button>
                    </div>
                </div>
            </el-dialog>

            <div class="ln-rodape">
                <el-button @click="voltar()">Voltar</el-button>
                <el-button v-if="!lancamento.somente_leitura && !turmaParecer" type="primary" :loading="salvando" @click="salvar()">Salvar</el-button>
            </div>
        </c-panel>

    </div>
</template>

<script>
// Lançamento de notas pela média do bimestre no web admin — spec_diario/notas/04.
// Por turma ("Todas as disciplinas": grade alunos × disciplinas) ou por disciplina (uma coluna).
// Salva só as células alteradas, com o valor original; o servidor devolve conflitos quando outra
// pessoa gravou a mesma célula no meio tempo. Mesma API do diário eletrônico (api/nota-periodo/*).
import Grade from './grade.vue'

export default {
    components: { Grade },
    data () {
        return {
            carregandoInit: false,
            carregando: false,
            salvando: false,
            instituicaoEscolhida: '',
            // Ano letivo da consulta; fora do corrente a API devolve tudo somente leitura.
            anoLetivo: Number(this.$store.state.config.parametros.periodo_letivo_situacao_academica) || '',
            dados: { turmas: [], pode_lancar_por_turma: false, media_minima: 5 },
            filtro: { turma: '', disciplina: '', periodo: '' },
            lancamento: null,
            alunos: [],
            anteriores: [],
            originais: {},
            erros: {},
            conflitos: {},
            parecer: { aberto: false, aluno: null, texto: '', salvando: false }
        }
    },
    computed: {
        precisaEscolherInstituicao () {
            return !this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id
        },
        instituicaoId () {
            return this.precisaEscolherInstituicao ? this.instituicaoEscolhida : this.$store.state.config.instituicao.id
        },
        // Professor vê só as turmas em que leciona; direção, coordenação, secretaria e SMED veem todas.
        turmasVisiveis () {
            if (this.$store.state.user.tipo == 2) {
                return this.dados.turmas.filter(t => t.minha_turma)
            }
            return this.dados.turmas
        },
        // Turma avaliada por parecer (1º ano, educação infantil…): sem nota, só o parecer por bimestre.
        turmaParecer () {
            return !!(this.turmaSelecionada && this.turmaSelecionada.metodo_avaliacao === 'qualitativo')
        },
        nomePeriodoAtual () {
            const p = this.periodos.find(x => x.periodo == this.filtro.periodo)
            return p ? p.nome : ''
        },
        turmaSelecionada () {
            return this.dados.turmas.find(t => t.id == this.filtro.turma) || null
        },
        disciplinas () {
            return this.turmaSelecionada ? this.turmaSelecionada.disciplinas : []
        },
        periodos () {
            return this.turmaSelecionada ? this.turmaSelecionada.periodos : []
        },
        filtrosCompletos () {
            return !!(this.filtro.turma && this.filtro.disciplina && this.filtro.periodo)
        },
        qtdConflitos () {
            return Object.keys(this.conflitos).length
        },
        professoresDaDisciplina () {
            if (!this.filtro.disciplina || this.filtro.disciplina == 'todas' || this.filtro.disciplina == 'parecer') return ''
            const d = this.disciplinas.find(x => String(x.id) == this.filtro.disciplina)
            return d && d.professores && d.professores.length ? d.professores.join(', ') : ''
        }
    },
    async mounted () {
        const q = this.$route.query
        if (this.precisaEscolherInstituicao && q.instituicao) this.instituicaoEscolhida = Number(q.instituicao)
        if (q.ano) this.anoLetivo = Number(q.ano)

        if (!this.instituicaoId) return

        await this.carregarInit()

        if (q.turma && this.turmasVisiveis.find(t => t.id == q.turma)) {
            this.filtro.turma = Number(q.turma)
            if (this.turmaParecer) this.filtro.disciplina = 'parecer'
            else if (q.disciplina && (q.disciplina == 'todas' ? this.dados.pode_lancar_por_turma : this.disciplinas.find(d => String(d.id) == q.disciplina))) this.filtro.disciplina = String(q.disciplina)
            else this.preSelecionarDisciplina()
            if (q.periodo && this.periodos.find(p => p.periodo == q.periodo)) this.filtro.periodo = String(q.periodo)
            if (this.filtrosCompletos) this.buscar()
        } else if (this.turmasVisiveis.length == 1) {
            this.aplicarFiltro('turma', this.turmasVisiveis[0].id)
        }
    },
    async beforeRouteLeave (to, from, next) {
        next(await this.confirmarDescarte())
    },
    methods: {
        chave (alunoId, discId) {
            return `${alunoId}-${discId}`
        },
        normal (v) {
            return (v === '' || v === null || v === undefined) ? null : Math.round(Number(v) * 100) / 100
        },
        // Células alteradas em relação ao que veio do servidor.
        alteradas () {
            const res = []
            for (const a of this.alunos) {
                for (const d of (this.lancamento ? this.lancamento.disciplinas : [])) {
                    if (!d.editavel) continue
                    const atual = this.normal(a.notas[d.id])
                    const orig = this.normal(this.originais[this.chave(a.aluno_id, d.id)])
                    if (atual !== orig) res.push({ aluno_id: a.aluno_id, disciplina_id: d.id, valor: atual, valor_original: orig })
                }
            }
            return res
        },
        alterado () {
            return !!this.lancamento && !this.lancamento.somente_leitura && this.alteradas().length > 0
        },
        periodoPendente (p) {
            if (this.filtro.disciplina && this.filtro.disciplina != 'todas' && this.filtro.disciplina != 'parecer') {
                const d = this.disciplinas.find(x => String(x.id) == this.filtro.disciplina)
                return !!(d && d.pendentes && d.pendentes.includes(p.periodo))
            }
            return !!p.pendente
        },
        async carregarInit () {
            this.carregandoInit = true
            try {
                const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/nota-periodo/init/${this.instituicaoId}${this.anoLetivo ? `?periodo_letivo_id=${this.anoLetivo}` : ''}`, this.$store.getters.getHeaderAuth)
                if (res.data && res.data.erro) {
                    window.eventBus.$emit('alert', { msg: res.data.erro.text || res.data.erro, type: 'warning' })
                    return
                }
                this.dados = res.data
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.carregandoInit = false
            }
        },
        async confirmarDescarte () {
            if (!this.alterado()) return true
            try {
                await this.$confirm('Há alterações não salvas. Descartar?', 'Atenção', { confirmButtonText: 'Descartar', cancelButtonText: 'Continuar editando', type: 'warning' })
                return true
            } catch (e) {
                return false
            }
        },
        async trocarInstituicao (v) {
            if (!(await this.confirmarDescarte())) return
            this.instituicaoEscolhida = v
            this.filtro = { turma: '', disciplina: '', periodo: '' }
            this.lancamento = null
            this.atualizarQuery()
            await this.carregarInit()
        },
        async trocarAnoLetivo (v) {
            if (v === this.anoLetivo) return
            if (!(await this.confirmarDescarte())) return
            this.anoLetivo = v
            this.filtro = { turma: '', disciplina: '', periodo: '' }
            this.lancamento = null
            this.atualizarQuery()
            if (this.instituicaoId) await this.carregarInit()
        },
        async trocarFiltro (campo, valor) {
            if (valor === this.filtro[campo]) return
            if (!(await this.confirmarDescarte())) return
            this.aplicarFiltro(campo, valor)
        },
        aplicarFiltro (campo, valor) {
            this.filtro[campo] = valor
            this.lancamento = null
            this.conflitos = {}
            this.erros = {}

            if (campo == 'turma') {
                this.filtro.disciplina = ''
                this.preSelecionarDisciplina()
            }
            if (campo == 'turma' || campo == 'disciplina') {
                this.filtro.periodo = ''
            }

            this.atualizarQuery()
            if (this.filtrosCompletos) this.buscar()
        },
        preSelecionarDisciplina () {
            if (this.turmaParecer) {
                this.filtro.disciplina = 'parecer'
            } else if (this.dados.pode_lancar_por_turma) {
                this.filtro.disciplina = 'todas'
            } else if (this.disciplinas.length == 1) {
                this.filtro.disciplina = String(this.disciplinas[0].id)
            }
        },
        atualizarQuery () {
            const query = {}
            if (this.precisaEscolherInstituicao && this.instituicaoEscolhida) query.instituicao = this.instituicaoEscolhida
            if (this.anoLetivo && this.anoLetivo != this.$store.state.config.parametros.periodo_letivo_situacao_academica) query.ano = this.anoLetivo
            if (this.filtro.turma) query.turma = this.filtro.turma
            if (this.filtro.disciplina) query.disciplina = this.filtro.disciplina
            if (this.filtro.periodo) query.periodo = this.filtro.periodo
            if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) this.$router.replace({ query }).catch(() => {})
        },
        async limpar (semConfirmar = false) {
            if (!semConfirmar && !(await this.confirmarDescarte())) return
            this.filtro = { turma: '', disciplina: '', periodo: '' }
            this.lancamento = null
            this.alunos = []
            this.anteriores = []
            this.erros = {}
            this.conflitos = {}
            this.atualizarQuery()
        },
        async buscar (manterConflitos = false) {
            if (!this.filtrosCompletos) return

            this.carregando = true
            this.erros = {}
            if (manterConflitos !== true) this.conflitos = {}

            try {
                const payload = {
                    turma_id: this.filtro.turma,
                    periodo: this.filtro.periodo,
                    disciplina_id: ['todas', 'parecer'].includes(this.filtro.disciplina) ? null : Number(this.filtro.disciplina)
                }
                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota-periodo/getLancamento`, payload, this.$store.getters.getHeaderAuth)

                if (res.data && res.data.erro) {
                    this.lancamento = null
                    window.eventBus.$emit('alert', { msg: res.data.erro.text || res.data.erro, type: 'warning' })
                    return
                }

                const orig = {}
                this.anteriores = res.data.matriculas_anteriores || []
                this.alunos = res.data.alunos.map(a => {
                    const notas = {}
                    for (const d of res.data.disciplinas) {
                        const v = a.notas[String(d.id)]
                        notas[d.id] = v === null || v === undefined ? '' : v
                        orig[this.chave(a.aluno_id, d.id)] = notas[d.id]
                    }
                    return { ...a, notas }
                })
                this.originais = orig
                this.lancamento = res.data
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.carregando = false
            }
        },
        async salvar () {
            // Nota digitada fora do formato (ex.: 10,5 ou 7,255) não chega ao modelo: bloqueia antes de enviar.
            if (this.$el.querySelector('input.nota-input[data-invalido="1"]')) {
                window.eventBus.$emit('alert', { msg: 'Há notas inválidas (marcadas em vermelho). Use de 0 a 10, com até duas casas decimais.', type: 'warning' })
                return
            }

            const celulas = this.alteradas()
            if (!celulas.length) {
                window.eventBus.$emit('alert', { msg: 'Nenhuma nota alterada.', type: 'warning' })
                return
            }

            this.salvando = true
            window.eventBus.$emit('loading', true)

            try {
                const payload = {
                    turma_id: this.filtro.turma,
                    periodo: this.filtro.periodo,
                    disciplina_id: ['todas', 'parecer'].includes(this.filtro.disciplina) ? null : Number(this.filtro.disciplina),
                    celulas
                }

                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota-periodo/store`, payload, this.$store.getters.getHeaderAuth)

                if (res.data && res.data.erro) {
                    const erro = res.data.erro
                    if (erro.celulas) {
                        const mapa = {}
                        for (const c of erro.celulas) mapa[this.chave(c.aluno_id, c.disciplina_id)] = c.mensagem
                        this.erros = mapa
                    }
                    window.eventBus.$emit('alert', { msg: erro.text || erro, type: 'warning' })
                    return
                }

                const novosConflitos = {}
                for (const c of (res.data.conflitos || [])) novosConflitos[this.chave(c.aluno_id, c.disciplina_id)] = c

                const gravadas = res.data.gravadas || 0
                if (Object.keys(novosConflitos).length) {
                    window.eventBus.$emit('alert', { msg: `${gravadas} nota(s) salva(s). ${Object.keys(novosConflitos).length} em conflito.`, type: 'warning' })
                } else {
                    window.eventBus.$emit('alert', { msg: res.data.mensagem || `${gravadas} nota(s) salva(s).`, type: 'success' })
                }

                // Guarda o que o usuário digitou nas células em conflito para reaplicar depois de recarregar.
                const digitado = {}
                for (const k of Object.keys(novosConflitos)) {
                    const [alunoId, discId] = k.split('-')
                    const a = this.alunos.find(x => String(x.aluno_id) == alunoId)
                    if (a) digitado[k] = a.notas[discId]
                }

                this.conflitos = novosConflitos
                await this.buscar(true)

                for (const k of Object.keys(digitado)) {
                    const [alunoId, discId] = k.split('-')
                    const a = this.alunos.find(x => String(x.aluno_id) == alunoId)
                    if (a) this.$set(a.notas, discId, digitado[k])
                }

                this.atualizarPendencias()
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.salvando = false
                window.eventBus.$emit('loading', false)
            }
        },
        // Duplo clique na célula em conflito: usa o valor que está no banco.
        aplicarConflito ({ aluno, disciplina }) {
            const k = this.chave(aluno.aluno_id, disciplina.id)
            const c = this.conflitos[k]
            if (!c) return
            this.$set(aluno.notas, disciplina.id, c.valor_atual === null ? '' : c.valor_atual)
            this.$set(this.originais, k, aluno.notas[disciplina.id])
            const resto = { ...this.conflitos }
            delete resto[k]
            this.conflitos = resto
        },
        // Atualiza as marcas de "pendente" do select a partir da grade carregada (sem recarregar o init).
        atualizarPendencias () {
            if (!this.lancamento || !this.turmaSelecionada) return
            const p = this.filtro.periodo
            for (const d of this.lancamento.disciplinas) {
                const disc = this.disciplinas.find(x => x.id == d.id)
                if (!disc) continue
                const vazia = this.alunos.some(a => !a.etiqueta && (a.notas[d.id] === '' || a.notas[d.id] === null))
                const pendentes = (disc.pendentes || []).filter(x => x != p)
                if (vazia) pendentes.push(p)
                this.$set(disc, 'pendentes', pendentes)
            }
        },
        abrirParecer (aluno) {
            this.parecer = { aberto: true, aluno, texto: aluno.parecer || '', salvando: false }
        },
        async salvarParecer () {
            const aluno = this.parecer.aluno
            this.parecer.salvando = true
            try {
                const payload = { turma_id: this.filtro.turma, periodo: this.filtro.periodo, aluno_id: aluno.aluno_id, parecer: this.parecer.texto }
                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota-periodo/storeParecer`, payload, this.$store.getters.getHeaderAuth)

                if (res.data && res.data.erro) {
                    window.eventBus.$emit('alert', { msg: res.data.erro.text || res.data.erro, type: 'warning' })
                    return
                }

                this.$set(aluno, 'parecer', String(this.parecer.texto || '').trim())
                this.parecer.aberto = false
                window.eventBus.$emit('alert', { msg: res.data.mensagem || 'Parecer salvo.', type: 'success' })
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.parecer.salvando = false
            }
        },
        voltar () {
            this.$router.push('/admin')
        },
        formatarDataHora (d) {
            return d ? this.$moment(d).format('DD/MM/YYYY HH:mm') : ''
        }
    }
}
</script>

<style>
    .lancamento-notas .ln-ultimo {
        font-size: 13px;
        color: #606266;
        margin-bottom: 8px;
    }
    .lancamento-notas .ln-professor {
        font-size: 13px;
        color: #606266;
        margin-top: 6px;
    }
    .ln-parecer-periodo {
        font-weight: 600;
        color: #606266;
        margin: 0 0 10px 0;
    }
    .lancamento-notas .ln-rodape {
        margin-top: 15px;
        text-align: right;
    }
    .ln-opcao-info {
        color: #909399;
        font-size: 12px;
    }
    .ln-opcao-pendente {
        color: #e6a23c;
        font-size: 12px;
        margin-left: 6px;
    }
</style>
